/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";

export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An arbitrary precision integer */
  Asn: { input: any; output: any };
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any };
  IPv4Address: { input: any; output: any };
  IPv4Network: { input: any; output: any };
  IPv6Address: { input: any; output: any };
  IPv6Network: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any };
  UUID: { input: string; output: string };
};

/** Information about wireless access point */
export type AccessPointType = {
  __typename?: "AccessPointType";
  brand?: Maybe<Scalars["String"]["output"]>;
  ciStatus?: Maybe<Scalars["String"]["output"]>;
  firmwareVersion?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  model?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  serialNumber?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  supplier?: Maybe<Scalars["String"]["output"]>;
};

/** Information about address */
export type AddressType = {
  __typename?: "AddressType";
  addition?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  extraAddressLine?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
  zipcode?: Maybe<Scalars["String"]["output"]>;
};

/** Affected subscription */
export type AffectedSubscriptionType = {
  __typename?: "AffectedSubscriptionType";
  impactType: Scalars["String"]["output"];
  subscription: ImpactedSubscriptionType;
  subscriptionId: Scalars["String"]["output"];
};

/** Information about aggregate parent of a service port */
export type AggregateParentType = {
  __typename?: "AggregateParentType";
  customerDescription: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  product: ProductType;
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about aggsp */
export type AggspSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "AggspSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  linkMemberSubscriptions: Array<LinkMemberDetailsType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services?: Maybe<Array<ServiceType>>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about AIRT Scan records */
export type AirtScan = {
  __typename?: "AirtScan";
  /** Contents of Intel MQ Classification field */
  classification?: Maybe<Scalars["JSON"]["output"]>;
  /** CRM Organisation UUID */
  customerId?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Destination field */
  destination?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Extra field */
  extra?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Feed field */
  feed?: Maybe<Scalars["JSON"]["output"]>;
  /** First time seen this message */
  firstSeen?: Maybe<Scalars["String"]["output"]>;
  /** Unique AIRT Scan record identifier */
  id: Scalars["String"]["output"];
  /** Datetime of import */
  importedAt: Scalars["String"]["output"];
  /** Last time seen this message */
  lastSeen?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Malware field */
  malware?: Maybe<Scalars["JSON"]["output"]>;
  /** Mongo collection version */
  modelVersion: Scalars["String"]["output"];
  /** The amount of hits on this IP in the queried time period */
  numberOfHits?: Maybe<Scalars["Int"]["output"]>;
  /** Contents of Intel MQ Protocol field */
  protocol?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of the Severity field */
  severity?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Source field */
  source?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Time field */
  time?: Maybe<Scalars["JSON"]["output"]>;
};

export type AirtScanConnection = {
  __typename?: "AirtScanConnection";
  edges: Array<AirtScanEdge>;
  pageInfo: PageInfo;
};

export type AirtScanEdge = {
  __typename?: "AirtScanEdge";
  cursor: Scalars["Int"]["output"];
  node: AirtScan;
};

export type AirtSort = {
  order: Array<AirtSortField>;
};

/** Sort ordering of results */
export type AirtSortField = {
  firstObservation?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  lastObservation?: InputMaybe<SortOrder>;
  scan?: InputMaybe<SortOrder>;
  severity?: InputMaybe<SortOrder>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type BaseSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Base sort ordering of results */
export type BaseSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

export enum Category {
  General = "GENERAL",
  Malfunction = "MALFUNCTION",
  Plannedwork = "PLANNEDWORK",
}

/** Information about a circuit */
export type CircuitType = {
  __typename?: "CircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

export type Counts = {
  __typename?: "Counts";
  /** Firewall subscriptions count */
  fw: SubscriptionCount;
  /** IP subscriptions count */
  ip: SubscriptionCount;
  /** IP Prefix subscriptions count */
  ipPrefix: SubscriptionCount;
  /** L2VPN subscriptions count */
  l2vpn: SubscriptionCountWithFirewallsEnabled;
  /** L3VPN subscriptions count */
  l3vpn: SubscriptionCountWithFirewallsEnabled;
  /** LightPath subscriptions count */
  lp: SubscriptionCount;
  /** Port subscriptions count */
  port: SubscriptionCount;
  /** SURFwired subscriptions count */
  wired: SubscriptionCount;
  /** SURFwireless subscriptions count */
  wireless: SubscriptionCount;
};

export type CountsFwArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsIpArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsIpPrefixArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsL2vpnArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsL3vpnArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsLpArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsPortArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsWiredArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsWirelessArgs = {
  customerId: Scalars["UUID"]["input"];
};

/** Information about customer */
export type CustomerType = {
  __typename?: "CustomerType";
  customerId: Scalars["UUID"]["output"];
  fullname: Scalars["String"]["output"];
};

/** DNS Firewall Type */
export type DnsFirewallType = {
  __typename?: "DNSFirewallType";
  action: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  hit: Scalars["String"]["output"];
  ipAddress: Scalars["String"]["output"];
  recordedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resolver: Scalars["String"]["output"];
  rpzFeed: Scalars["String"]["output"];
};

export type DnsFirewallTypeConnection = {
  __typename?: "DNSFirewallTypeConnection";
  edges: Array<DnsFirewallTypeEdge>;
  pageInfo: PageInfo;
};

export type DnsFirewallTypeEdge = {
  __typename?: "DNSFirewallTypeEdge";
  cursor: Scalars["Int"]["output"];
  node: DnsFirewallType;
};

/** Filter DNS Firewall by attribute, all ranges are inclusive */
export type DnsFirewallSearchFilter = {
  /** Case insensitive on Action */
  action?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results after import date */
  afterRecordedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before import date */
  beforeRecordedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Case insensitive on Hit */
  hit?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive search on ip address */
  ipAddress?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on IP prefixes */
  ipPrefixes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Case insensitive on Resolver */
  resolver?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive on RPZ Feed */
  rpzFeed?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type DnsFirewallSort = {
  order: Array<DnsFirewallSortField>;
};

/** Sort ordering of results */
export type DnsFirewallSortField = {
  action?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  hit?: InputMaybe<SortOrder>;
  ipAddress?: InputMaybe<SortOrder>;
  recordedAt?: InputMaybe<SortOrder>;
  resolver?: InputMaybe<SortOrder>;
  rpzFeed?: InputMaybe<SortOrder>;
};

/** Information about ESI */
export type EthernetSegmentIdentifierType = {
  __typename?: "EthernetSegmentIdentifierType";
  endpoints?: Maybe<Array<ServiceAttachPointType>>;
  firewallInterconnect?: Maybe<L2InterconnectType>;
  segmentId?: Maybe<Scalars["Int"]["output"]>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type EvpnPtpSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type EvpnPtpSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about firewall */
export type FirewallSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "FirewallSubscriptionDetailsType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerAsn?: Maybe<Scalars["Asn"]["output"]>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  fwAsn: Scalars["Asn"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipGateway?: Maybe<IpGatewayType>;
  l2Endpoints: Array<L2EndpointType>;
  l3Endpoints: Array<L3EndpointType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type FirewallSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type FirewallSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFfirewall */
export type FirewallSubscriptionType = SubscriptionDetails & {
  __typename?: "FirewallSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type FirewallSubscriptionTypeConnectionV2 = {
  __typename?: "FirewallSubscriptionTypeConnectionV2";
  page: Array<FirewallSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about ip service attach point */
export type IpServiceAttachPointType = {
  __typename?: "IPServiceAttachPointType";
  address?: Maybe<AddressType>;
  bfd?: Maybe<Scalars["Boolean"]["output"]>;
  bfdMinimumInterval?: Maybe<Scalars["Int"]["output"]>;
  bfdMultiplier?: Maybe<Scalars["Int"]["output"]>;
  bgpExportPolicy?: Maybe<Scalars["String"]["output"]>;
  bgpHashAlgorithm?: Maybe<Scalars["String"]["output"]>;
  bgpPassword?: Maybe<Scalars["String"]["output"]>;
  bgpSessionPriority?: Maybe<Scalars["String"]["output"]>;
  gracefulRestart?: Maybe<Scalars["Boolean"]["output"]>;
  ipPrefixes: Array<Scalars["String"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4PointToPointPrefix?: Maybe<IpPointToPointPrefixType>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6PointToPointPrefix?: Maybe<IpPointToPointPrefixType>;
  name: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  ownerSubscriptionId: Scalars["UUID"]["output"];
  port?: Maybe<ServicePortSubscriptionType>;
  portSubscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanrange: Scalars["String"]["output"];
};

export type IpSubscriptionListItemType = {
  __typename?: "IPSubscriptionListItemType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  product: ProductType;
  subscriptionId: Scalars["UUID"]["output"];
};

export enum Impact {
  Down = "DOWN",
  NoImpact = "NO_IMPACT",
  ReducedRedundancy = "REDUCED_REDUNDANCY",
  ResilienceLoss = "RESILIENCE_LOSS",
  Unknown = "UNKNOWN",
}

/** Impacted subscription */
export type ImpactedSubscriptionType = {
  __typename?: "ImpactedSubscriptionType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  product?: Maybe<ProductType>;
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about ip gateway */
export type IpGatewayType = {
  __typename?: "IpGatewayType";
  ipPrefixes: Array<Scalars["String"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  multiCast: Scalars["Boolean"]["output"];
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfcertFilter: Scalars["String"]["output"];
  upLinkLocations: Array<UplinkLocationType>;
};

/** Information about ip ptp prefix */
export type IpPointToPointPrefixType = {
  __typename?: "IpPointToPointPrefixType";
  clientFQDN: Scalars["String"]["output"];
  clientIpAddress: Scalars["String"]["output"];
  network: Scalars["String"]["output"];
  surfFQDN: Scalars["String"]["output"];
  surfIpAddress: Scalars["String"]["output"];
};

/** Information about ip_prefix ddos */
export type IpPrefixDdosType = {
  __typename?: "IpPrefixDdosType";
  afi: Scalars["Int"]["output"];
  autoMitigation?: Maybe<Scalars["Boolean"]["output"]>;
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty?: Maybe<Scalars["Boolean"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  prefix: Scalars["String"]["output"];
  prefixType?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  version: Scalars["Int"]["output"];
};

export type IpPrefixDdosTypeConnectionV2 = {
  __typename?: "IpPrefixDdosTypeConnectionV2";
  page: Array<IpPrefixDdosType>;
  pageInfo: PageInfo;
};

/** Filter list by attribute, all ranges are inclusive */
export type IpPrefixSubscriptionDdosFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type IpPrefixSubscriptionDdosSort = {
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  ipPrefix?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type IpPrefixSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type IpPrefixSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about ipprefix */
export type IpPrefixSubscriptionType = SubscriptionDetails & {
  __typename?: "IpPrefixSubscriptionType";
  autoMitigation: Scalars["String"]["output"];
  availableIpSubscriptions: Array<IpSubscriptionListItemType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipPrefix?: Maybe<IpPrefixType>;
  ipSubscriptions: Array<IpSubscriptionListItemType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type IpPrefixSubscriptionTypeConnectionV2 = {
  __typename?: "IpPrefixSubscriptionTypeConnectionV2";
  page: Array<IpPrefixSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about ipprefix */
export type IpPrefixType = {
  __typename?: "IpPrefixType";
  afi: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  ipamPrefixId: Scalars["Int"]["output"];
  ipamPrefixTags?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  parentLabel?: Maybe<Scalars["String"]["output"]>;
  prefix: Scalars["String"]["output"];
  state: Scalars["Int"]["output"];
  stateLabel?: Maybe<Scalars["String"]["output"]>;
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  tag?: Maybe<Scalars["String"]["output"]>;
  vrf: Scalars["Int"]["output"];
  vrfLabel?: Maybe<Scalars["String"]["output"]>;
};

/** Information about ip service settings */
export type IpServiceSettingsType = {
  __typename?: "IpServiceSettingsType";
  asn?: Maybe<Scalars["Int"]["output"]>;
  multicast?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  surfcertFilter: Scalars["String"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about ip */
export type IpSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "IpSubscriptionDetailsType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  circuits: Array<CircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipRoutingType: Scalars["String"]["output"];
  ipss: IpServiceSettingsType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  saps: Array<IpServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Information about IP */
export type IpSubscriptionListType = SubscriptionDetails & {
  __typename?: "IpSubscriptionListType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipRoutingType: Scalars["String"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type IpSubscriptionListTypeConnectionV2 = {
  __typename?: "IpSubscriptionListTypeConnectionV2";
  page: Array<IpSubscriptionListType>;
  pageInfo: PageInfo;
};

/** Information about irb */
export type IrbSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "IrbSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services: Array<ServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about L2 endpoint */
export type L2EndpointType = {
  __typename?: "L2EndpointType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  ipv4PtpPrefixes: Array<Scalars["Int"]["output"]>;
  ipv6PtpPrefixes: Array<Scalars["Int"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
};

/** Information about L2 Interconnect */
export type L2InterconnectType = {
  __typename?: "L2InterconnectType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["UUID"]["output"]>;
  description: Scalars["String"]["output"];
  endpoints?: Maybe<Array<ServiceAttachPointType>>;
  firewallSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  saps: Array<ServiceAttachPointType>;
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
};

/** Information about L2VPN circuit */
export type L2VpnCircuitType = {
  __typename?: "L2VPNCircuitType";
  bumFilter?: Maybe<Scalars["Boolean"]["output"]>;
  endpoints: Array<ServiceAttachPointType>;
  esis: Array<EthernetSegmentIdentifierType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanRetagging?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Information about L2VPN */
export type L2VpnSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "L2VPNSubscriptionDetailsType";
  circuits: Array<L2VpnCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  esis: Array<EthernetSegmentIdentifierType>;
  firewallEnabled: Scalars["Boolean"]["output"];
  firewallInterconnects: Array<L2InterconnectType>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  saps: Array<ServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type L2VpnSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type L2VpnSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about l2vpn */
export type L2VpnSubscriptionType = {
  __typename?: "L2VpnSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type L2VpnSubscriptionTypeConnectionV2 = {
  __typename?: "L2VpnSubscriptionTypeConnectionV2";
  page: Array<L2VpnSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about L3 endpoint */
export type L3EndpointType = {
  __typename?: "L3EndpointType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
};

/** Information about L3VPN firewall interconnect */
export type L3FwInterconnectType = {
  __typename?: "L3FwInterconnectType";
  availabilityZone: Scalars["String"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  firewallAsn: Scalars["String"]["output"];
  firewallSubscriptionId: Scalars["UUID"]["output"];
  ipv4AddressFirewall?: Maybe<Scalars["IPv4Address"]["output"]>;
  ipv4MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4Prefix?: Maybe<Scalars["IPv4Network"]["output"]>;
  ipv6AddressFirewall?: Maybe<Scalars["IPv6Address"]["output"]>;
  ipv6MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6Prefix?: Maybe<Scalars["IPv6Network"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  saps: Array<ServiceAttachPointType>;
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
};

/** Information about L3VPN circuit */
export type L3VpnCircuitType = {
  __typename?: "L3VPNCircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN service settings */
export type L3VpnsapServiceSettingsType = {
  __typename?: "L3VPNSAPServiceSettingsType";
  asn: Scalars["Int"]["output"];
  bfd?: Maybe<Scalars["Boolean"]["output"]>;
  bfdMinimumInterval?: Maybe<Scalars["Int"]["output"]>;
  bfdMultiplier?: Maybe<Scalars["Int"]["output"]>;
  bgpMetric?: Maybe<Scalars["String"]["output"]>;
  bgpPassword?: Maybe<Scalars["String"]["output"]>;
  ipv4Address?: Maybe<Scalars["String"]["output"]>;
  ipv4MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4RemoteAddress?: Maybe<Scalars["String"]["output"]>;
  ipv6Address?: Maybe<Scalars["String"]["output"]>;
  ipv6MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6RemoteAddress?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  sap: ServiceAttachPointType;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN service settings */
export type L3VpnServiceSettingsType = {
  __typename?: "L3VPNServiceSettingsType";
  l3vpnAsn: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN */
export type L3VpnSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "L3VPNSubscriptionDetailsType";
  circuits: Array<L3VpnCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  firewallInterconnects: Array<L3FwInterconnectType>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  l3vpnsapss: Array<L3VpnsapServiceSettingsType>;
  l3vpnss: L3VpnServiceSettingsType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type L3VpnSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type L3VpnSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about l3vpn */
export type L3VpnSubscriptionType = {
  __typename?: "L3VpnSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type L3VpnSubscriptionTypeConnectionV2 = {
  __typename?: "L3VpnSubscriptionTypeConnectionV2";
  page: Array<L3VpnSubscriptionType>;
  pageInfo: PageInfo;
};

export enum Language {
  Eng = "ENG",
  Nl = "NL",
}

/** Information about light path circuit */
export type LightPathCircuitType = {
  __typename?: "LightPathCircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  remotePortShutdown?: Maybe<Scalars["Boolean"]["output"]>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about light path */
export type LightPathSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "LightPathSubscriptionDetailsType";
  circuits: Array<LightPathCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  remotePortShutdown: Scalars["Boolean"]["output"];
  saps: Array<ServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Information about lightpath */
export type LightPathSubscriptionType = SubscriptionDetails & {
  __typename?: "LightPathSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  services: Array<PortServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type LightPathSubscriptionTypeConnectionV2 = {
  __typename?: "LightPathSubscriptionTypeConnectionV2";
  page: Array<LightPathSubscriptionType>;
  pageInfo: PageInfo;
};

export type LinkMemberDetailsType = {
  __typename?: "LinkMemberDetailsType";
  amountReserved: Scalars["Int"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  ieeeInterfaceType?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  patchPosition?: Maybe<Scalars["String"]["output"]>;
  portSpeed: Scalars["Int"]["output"];
  product: ProductType;
  services: Array<ServiceType>;
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** Information about a location (e.g. address, description, code) */
export type LocationType = {
  __typename?: "LocationType";
  address?: Maybe<AddressType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
};

/** Filter major disruption notifications */
export type MajorDisruptionNotificationFilter = {
  /** Show notifications on and after this start date */
  beginTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription owner. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Show notifications on and before this end date, or without end date */
  endTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by notification statuses */
  statuses?: Array<ProcessState>;
};

export type MscPortSubscriptionType = {
  __typename?: "MscPortSubscriptionType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about msc */
export type MscSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "MscSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<MscPortSubscriptionType>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceTag?: Maybe<Scalars["Int"]["output"]>;
  services: Array<ServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Filter for regular notifications */
export type NotificationFilter = {
  /** Use this customer for custom fields like 'customer_description' */
  accessCustomerId: Scalars["UUID"]["input"];
  /** Show notifications on and after this start date */
  beginTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription owner. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Show notifications on and before this end date, or without end date */
  endTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription impacts. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  impacts?: InputMaybe<Array<Impact>>;
  /** Filter by subscription product types. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  productTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by notification statuses */
  statuses?: Array<ProcessState>;
  /** Filter by subscription ids. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  subscriptionIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

/** CIM notification */
export type NotificationType = {
  __typename?: "NotificationType";
  affectedSubscriptions: Array<AffectedSubscriptionType>;
  category: Category;
  createDate: Scalars["DateTime"]["output"];
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  heading: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  impact: Scalars["String"]["output"];
  notificationId: Scalars["String"]["output"];
  planDate?: Maybe<Scalars["DateTime"]["output"]>;
  processState: ProcessState;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  summary: Scalars["String"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  type: TicketType;
  updates: Array<NotificationUpdate>;
  urgency: Urgency;
};

export type NotificationUpdate = {
  __typename?: "NotificationUpdate";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  language: Language;
  timestamp: Scalars["DateTime"]["output"];
};

/** Pagination context to navigate objects with cursor-based pagination */
export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["Int"]["output"]>;
  filterFields: Array<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  sortFields: Array<Scalars["String"]["output"]>;
  startCursor?: Maybe<Scalars["Int"]["output"]>;
  totalItems?: Maybe<Scalars["Int"]["output"]>;
};

/** Information about a service on a port */
export type PortServiceType = {
  __typename?: "PortServiceType";
  description: Scalars["String"]["output"];
  percentage: Scalars["Float"]["output"];
  productType: Scalars["String"]["output"];
  speed: Scalars["Int"]["output"];
  subscriptionId: Scalars["String"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type PortSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of port results */
export type PortSubscriptionSort = {
  amountReserved?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  portMode?: InputMaybe<SortOrder>;
  portSpeed?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

export type PrivateQuery = {
  __typename?: "PrivateQuery";
  /** Return aggsp details */
  aggspDetails: AggspSubscriptionDetailsType;
  /** Returns a list of AIRT Scans */
  airtScans: AirtScanConnection;
  /** Grouped subscription counts */
  counts: Counts;
  /** Get all subscriptions */
  customerSubscriptions: Array<SubscriptionType>;
  /** Returns a list of DNS Firewall logs */
  dnsFirewallLogs: DnsFirewallTypeConnection;
  /** Returns a list of evpn ptp subscriptions */
  evpnPtpList: LightPathSubscriptionTypeConnectionV2;
  /** Return firewall details */
  firewallDetails: FirewallSubscriptionDetailsType;
  /** Return a list of firewall subscriptions */
  firewallList: FirewallSubscriptionTypeConnectionV2;
  /** Return ip bgp details */
  ipBgpDetails: IpSubscriptionDetailsType;
  /** Return IP list */
  ipList: IpSubscriptionListTypeConnectionV2;
  /** Return ip prefix ddos list */
  ipPrefixDdos: IpPrefixDdosTypeConnectionV2;
  /** Return ip prefix list */
  ipPrefixList: IpPrefixSubscriptionTypeConnectionV2;
  /** Return ip static details */
  ipStaticDetails: IpSubscriptionDetailsType;
  /** Return irb details */
  irbDetails: IrbSubscriptionDetailsType;
  /** Return L2VPN details */
  l2vpnDetails: L2VpnSubscriptionDetailsType;
  /** Returns a list of l2vpn subscriptions */
  l2vpnList: L2VpnSubscriptionTypeConnectionV2;
  /** Return L2VPN details */
  l3vpnDetails: L3VpnSubscriptionDetailsType;
  /** Returns a list of l3vpn subscriptions */
  l3vpnList: L3VpnSubscriptionTypeConnectionV2;
  /** Return lightpath details */
  lpDetails: LightPathSubscriptionDetailsType;
  /** Return lightpath redundant details */
  lrDetails: LightPathSubscriptionDetailsType;
  /** Return major disruption notifications */
  majorDisruptionNotifications: Array<NotificationType>;
  /** Return msc details */
  mscDetails: MscSubscriptionDetailsType;
  /** Return all notifications */
  notifications: Array<NotificationType>;
  /** Returns a list of port subscriptions */
  portList: ServicePortSubscriptionTypeConnectionV2;
  /** Return service port details */
  servicePortDetails: ServicePortSubscriptionDetailsType;
  /** Return subscription_status */
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  /** Return list subscriptions with surf_cert info */
  surfCertList: SurfCertTypeConnectionV2;
  /** Return wired details */
  wiredDetails: WiredSubscriptionDetailsType;
  /** Return a list of wired subscriptions */
  wiredList: WiredSubscriptionTypeConnectionV2;
  /** Return wireless details */
  wirelessDetails: WirelessSubscriptionDetailsType;
  /** Return a list of wireless subscriptions */
  wirelessList: WirelessSubscriptionTypeConnectionV2;
  /** Return open SURFwireless SNTT tickets across an organisation's wireless locations */
  wirelessOrganisationTickets: Array<WirelessTicketType>;
};

export type PrivateQueryAggspDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryAirtScansArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<SearchFilter>;
  sort?: InputMaybe<AirtSort>;
};

export type PrivateQueryCustomerSubscriptionsArgs = {
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]>>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PrivateQueryDnsFirewallLogsArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter: DnsFirewallSearchFilter;
  sort?: InputMaybe<DnsFirewallSort>;
};

export type PrivateQueryEvpnPtpListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<EvpnPtpSubscriptionFilter>;
  sort?: InputMaybe<EvpnPtpSubscriptionSort>;
};

export type PrivateQueryFirewallDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryFirewallListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<FirewallSubscriptionFilter>;
  sort?: InputMaybe<FirewallSubscriptionSort>;
};

export type PrivateQueryIpBgpDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryIpListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<BaseSubscriptionFilter>;
  sort?: InputMaybe<BaseSubscriptionSort>;
};

export type PrivateQueryIpPrefixDdosArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<IpPrefixSubscriptionDdosFilter>;
  sort?: InputMaybe<IpPrefixSubscriptionDdosSort>;
};

export type PrivateQueryIpPrefixListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<IpPrefixSubscriptionFilter>;
  sort?: InputMaybe<IpPrefixSubscriptionSort>;
};

export type PrivateQueryIpStaticDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryIrbDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL2vpnDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL2vpnListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<L2VpnSubscriptionFilter>;
  sort?: InputMaybe<L2VpnSubscriptionSort>;
};

export type PrivateQueryL3vpnDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL3vpnListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<L3VpnSubscriptionFilter>;
  sort?: InputMaybe<L3VpnSubscriptionSort>;
};

export type PrivateQueryLpDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryLrDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryMajorDisruptionNotificationsArgs = {
  searchFilter: MajorDisruptionNotificationFilter;
};

export type PrivateQueryMscDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryNotificationsArgs = {
  searchFilter: NotificationFilter;
};

export type PrivateQueryPortListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<PortSubscriptionFilter>;
  sort?: InputMaybe<PortSubscriptionSort>;
};

export type PrivateQueryServicePortDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQuerySubscriptionStatusArgs = {
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQuerySurfCertListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<SurfCertFilter>;
  sort?: InputMaybe<SurfCertSort>;
};

export type PrivateQueryWiredDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryWiredListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<WiredSubscriptionFilter>;
  sort?: InputMaybe<WiredSubscriptionSort>;
};

export type PrivateQueryWirelessDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryWirelessListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<WirelessSubscriptionFilter>;
  sort?: InputMaybe<WirelessSubscriptionSort>;
};

export type PrivateQueryWirelessOrganisationTicketsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export enum ProcessState {
  Aborted = "ABORTED",
  Closed = "CLOSED",
  ClosedWithoutInform = "CLOSED_WITHOUT_INFORM",
  New = "NEW",
  Open = "OPEN",
  OpenAccepted = "OPEN_ACCEPTED",
  OpenRelated = "OPEN_RELATED",
  Updated = "UPDATED",
}

/** Information about product */
export type ProductType = {
  __typename?: "ProductType";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  tag: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

/** Metadata to reference customer specific ID's */
export type ReferenceType = {
  __typename?: "ReferenceType";
  externalId: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** Filter airt scans by attribute, all ranges are inclusive */
export type SearchFilter = {
  /** Return results after import date */
  afterImportedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results after observation date */
  afterObservationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results after source date */
  afterSourceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Search on application. E.g. ftp, ssh */
  application?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results before import date */
  beforeImportedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before observation date */
  beforeObservationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before date */
  beforeSourceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Case insensitive search on city */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by classification key/value pairs */
  classification?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search on IP address */
  ip?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered before destination IP */
  ipDestinationEnd?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered before destination IP */
  ipDestinationStart?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on IP address */
  ipPrefixesDestination?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search on IP address */
  ipPrefixesSource?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Return results filtered before source IP */
  ipSourceEnd?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered after source IP */
  ipSourceStart?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on protocol: TCP/UDP/ICMP */
  protocol?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive on region */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** The severity of the case. */
  severity?: InputMaybe<Array<Severity>>;
};

/** Information about service attach point */
export type ServiceAttachPointType = {
  __typename?: "ServiceAttachPointType";
  address?: Maybe<AddressType>;
  name: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  ownerSubscriptionId: Scalars["UUID"]["output"];
  port?: Maybe<ServicePortSubscriptionType>;
  portSubscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanrange: Scalars["String"]["output"];
};

/** Information about port */
export type ServicePortSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "ServicePortSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  aggregateParent?: Maybe<AggregateParentType>;
  amountReserved: Scalars["Int"]["output"];
  autoNegotiation?: Maybe<Scalars["Boolean"]["output"]>;
  connectorType?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  fiberType?: Maybe<Scalars["String"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  ieeeInterfaceType?: Maybe<Scalars["String"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  patchPosition?: Maybe<Scalars["String"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services?: Maybe<Array<ServiceType>>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about port */
export type ServicePortSubscriptionType = {
  __typename?: "ServicePortSubscriptionType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portMode: Scalars["String"]["output"];
  portSpeed: Scalars["Int"]["output"];
  product: ProductType;
  references: Array<ReferenceType>;
  services: Array<ServiceType>;
  speed?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  usedVlans: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type ServicePortSubscriptionTypeConnectionV2 = {
  __typename?: "ServicePortSubscriptionTypeConnectionV2";
  page: Array<ServicePortSubscriptionType>;
  pageInfo: PageInfo;
};

/** information about service port services */
export type ServiceType = {
  __typename?: "ServiceType";
  amountReserved: Scalars["Int"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  insync: Scalars["Boolean"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  percentage: Scalars["Float"]["output"];
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscriptionInstanceId: Scalars["UUID"]["output"];
  product: ProductType;
  sapSubscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  services?: Maybe<Array<ServiceType>>;
  speed: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** The severity of the item */
export enum Severity {
  Critical = "CRITICAL",
  High = "HIGH",
  Info = "INFO",
  Low = "LOW",
  Medium = "MEDIUM",
}

/** Sort direction: ascending or descending */
export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type SubscriptionCount = {
  __typename?: "SubscriptionCount";
  all: Scalars["Int"]["output"];
  inactive: Scalars["Int"]["output"];
  malfunction: Scalars["Int"]["output"];
  notfound: Scalars["Int"]["output"];
  notraffic: Scalars["Int"]["output"];
  ok: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  unknown: Scalars["Int"]["output"];
};

export type SubscriptionCountWithFirewallsEnabled = {
  __typename?: "SubscriptionCountWithFirewallsEnabled";
  all: Scalars["Int"]["output"];
  firewallsEnabled: Scalars["Int"]["output"];
  inactive: Scalars["Int"]["output"];
  malfunction: Scalars["Int"]["output"];
  notfound: Scalars["Int"]["output"];
  notraffic: Scalars["Int"]["output"];
  ok: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  unknown: Scalars["Int"]["output"];
};

export type SubscriptionDetails = {
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export enum SubscriptionLifecycle {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Initial = "INITIAL",
  Migrating = "MIGRATING",
  Provisioning = "PROVISIONING",
  Terminated = "TERMINATED",
}

/** Subscription status */
export type SubscriptionStatus = {
  __typename?: "SubscriptionStatus";
  productTag?: Maybe<Scalars["String"]["output"]>;
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

/** Base subscription info */
export type SubscriptionType = {
  __typename?: "SubscriptionType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type SurfCertFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type SurfCertSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about surfcert */
export type SurfCertType = {
  __typename?: "SurfCertType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  insync: Scalars["Boolean"]["output"];
  productTag: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["String"]["output"];
  surfcertFilterEnabled: Scalars["Boolean"]["output"];
};

export type SurfCertTypeConnectionV2 = {
  __typename?: "SurfCertTypeConnectionV2";
  page: Array<SurfCertType>;
  pageInfo: PageInfo;
};

export enum TicketType {
  Incident = "INCIDENT",
  MajorDisruption = "MAJOR_DISRUPTION",
  PlannedWork = "PLANNED_WORK",
}

/** Information about topology object */
export type TopologyObjectType = {
  __typename?: "TopologyObjectType";
  customerDescription: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product?: Maybe<ProductType>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  topologyObjectType: Scalars["String"]["output"];
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** Information about uplink location */
export type UplinkLocationType = {
  __typename?: "UplinkLocationType";
  address?: Maybe<AddressType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
};

export enum Urgency {
  High = "HIGH",
  Normal = "NORMAL",
}

/** Information about wired */
export type WiredSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "WiredSubscriptionDetailsType";
  customCustomerAbbreviation?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  monitoringEnabled: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type WiredSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type WiredSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFwired */
export type WiredSubscriptionType = SubscriptionDetails & {
  __typename?: "WiredSubscriptionType";
  customCustomerAbbreviation?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  monitoringEnabled: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type WiredSubscriptionTypeConnectionV2 = {
  __typename?: "WiredSubscriptionTypeConnectionV2";
  page: Array<WiredSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about wireless */
export type WirelessLocationActivityType = {
  __typename?: "WirelessLocationActivityType";
  activeAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  inactiveAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  institute?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Information about wireless location */
export type WirelessLocationDetailsType = {
  __typename?: "WirelessLocationDetailsType";
  accessPoints: Array<AccessPointType>;
  activeAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  inactiveAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  institute?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Information about wireless */
export type WirelessSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "WirelessSubscriptionDetailsType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  location?: Maybe<WirelessLocationDetailsType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  sensorPresent: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  supplier: Scalars["String"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  tickets: Array<WirelessTicketType>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type WirelessSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type WirelessSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFwireless */
export type WirelessSubscriptionType = SubscriptionDetails & {
  __typename?: "WirelessSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  jiraLocationId?: Maybe<Scalars["String"]["output"]>;
  location: WirelessLocationActivityType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  sensorPresent: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  supplier: Scalars["String"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type WirelessSubscriptionTypeConnectionV2 = {
  __typename?: "WirelessSubscriptionTypeConnectionV2";
  page: Array<WirelessSubscriptionType>;
  pageInfo: PageInfo;
};

/** Status of a SURFwireless SNTT ticket */
export type WirelessTicketStatusType = {
  __typename?: "WirelessTicketStatusType";
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

/** A SURFwireless SNTT (Jira) service ticket */
export type WirelessTicketType = {
  __typename?: "WirelessTicketType";
  created: Scalars["DateTime"]["output"];
  locations: Array<Scalars["String"]["output"]>;
  status: WirelessTicketStatusType;
  summary?: Maybe<Scalars["String"]["output"]>;
  ticketId: Scalars["String"]["output"];
};

export type GetAirtScansQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<AirtSort>;
}>;

export type GetAirtScansQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: {
        __typename?: "AirtScan";
        id: string;
        importedAt: string;
        modelVersion: string;
        classification?: any | null;
        destination?: any | null;
        extra?: any | null;
        feed?: any | null;
        malware?: any | null;
        source?: any | null;
        time?: any | null;
        protocol?: any | null;
        numberOfHits?: number | null;
        lastSeen?: string | null;
        firstSeen?: string | null;
        severity?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo" } & { " $fragmentRefs"?: { PaginationInfoFragment: PaginationInfoFragment } };
  };
};

export type GetAirtScansClassificationProtocolQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;

export type GetAirtScansClassificationProtocolQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: { __typename?: "AirtScan"; classification?: any | null; protocol?: any | null; severity?: string | null };
    }>;
  };
};

export type GetAirtScansCountQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAirtScansCountQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: {
        __typename?: "AirtScan";
        id: string;
        classification?: any | null;
        protocol?: any | null;
        severity?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo" } & { " $fragmentRefs"?: { PaginationInfoFragment: PaginationInfoFragment } };
  };
};

export type CertMitigationPrefixesQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type CertMitigationPrefixesQuery = {
  __typename?: "PrivateQuery";
  ipPrefixDdos: {
    __typename?: "IpPrefixDdosTypeConnectionV2";
    page: Array<{
      __typename?: "IpPrefixDdosType";
      subscriptionId: string;
      autoMitigation?: boolean | null;
      customerId: string;
      description: string;
      insync: boolean;
      prefix: string;
      status: string;
      version: number;
      afi: number;
      dirty?: boolean | null;
    }>;
  };
};

export type CimNotificationFragment = {
  __typename?: "NotificationType";
  category: Category;
  endDate?: any | null;
  heading: string;
  id: string;
  impact: string;
  planDate?: any | null;
  startDate?: any | null;
  status: string;
  summary: string;
  tags: Array<string>;
  type: TicketType;
  urgency: Urgency;
  updates: Array<{ __typename?: "NotificationUpdate"; language: Language; description: string; timestamp: any }>;
} & { " $fragmentName"?: "CimNotificationFragment" };

export type CimAffectedSubscriptionsFragment = {
  __typename?: "NotificationType";
  affectedSubscriptions?: Array<{
    __typename?: "AffectedSubscriptionType";
    subscriptionId: string;
    impactType: string;
    subscription: {
      __typename?: "ImpactedSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
      customerDescription: string;
      product?: { __typename?: "ProductType"; type: string; name: string } | null;
    };
  }>;
} & { " $fragmentName"?: "CimAffectedSubscriptionsFragment" };

export type CimNotificationsQueryVariables = Exact<{
  filter: NotificationFilter;
  includeAffectedSubscriptions?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CimNotificationsQuery = {
  __typename?: "PrivateQuery";
  notifications: Array<
    { __typename?: "NotificationType" } & {
      " $fragmentRefs"?: {
        CimNotificationFragment: CimNotificationFragment;
        CimAffectedSubscriptionsFragment: CimAffectedSubscriptionsFragment;
      };
    }
  >;
};

export type CimNotificationsSubscriptionQueryVariables = Exact<{
  filter: NotificationFilter;
}>;

export type CimNotificationsSubscriptionQuery = {
  __typename?: "PrivateQuery";
  notifications: Array<
    { __typename?: "NotificationType" } & { " $fragmentRefs"?: { CimNotificationFragment: CimNotificationFragment } }
  >;
};

export type CimMajorDisruptionNotificationsQueryVariables = Exact<{
  filter: MajorDisruptionNotificationFilter;
}>;

export type CimMajorDisruptionNotificationsQuery = {
  __typename?: "PrivateQuery";
  majorDisruptionNotifications: Array<
    { __typename?: "NotificationType" } & { " $fragmentRefs"?: { CimNotificationFragment: CimNotificationFragment } }
  >;
};

export type CustomerWithMinimalImpactNotificationQueryQueryVariables = Exact<{
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type CustomerWithMinimalImpactNotificationQueryQuery = {
  __typename?: "PrivateQuery";
  customerSubscriptions: Array<{
    __typename?: "SubscriptionType";
    subscriptionId: string;
    minimalImpactNotification?: string | null;
    description: string;
    customerDescription: string;
    product: { __typename?: "ProductType"; type: string };
  }>;
};

export type GetDnsFirewallQueryVariables = Exact<{
  filter?: InputMaybe<DnsFirewallSearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<DnsFirewallSort>;
}>;

export type GetDnsFirewallQuery = {
  __typename?: "PrivateQuery";
  dnsFirewallLogs: {
    __typename?: "DNSFirewallTypeConnection";
    edges: Array<{
      __typename?: "DNSFirewallTypeEdge";
      cursor: number;
      node: {
        __typename?: "DNSFirewallType";
        customerId: string;
        ipAddress: string;
        rpzFeed: string;
        hit: string;
        recordedAt?: any | null;
        resolver: string;
        action: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo" } & { " $fragmentRefs"?: { PaginationInfoFragment: PaginationInfoFragment } };
  };
};

export type PaginationInfoFragment = {
  __typename?: "PageInfo";
  endCursor?: number | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: number | null;
  totalItems?: number | null;
} & { " $fragmentName"?: "PaginationInfoFragment" };

type BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment = {
  __typename?: "AggspSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment = {
  __typename?: "FirewallSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_FirewallSubscriptionType_Fragment = {
  __typename?: "FirewallSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_FirewallSubscriptionType_Fragment" };

type BaseSubscriptionFragment_IpPrefixSubscriptionType_Fragment = {
  __typename?: "IpPrefixSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_IpPrefixSubscriptionType_Fragment" };

type BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment = {
  __typename?: "IpSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_IpSubscriptionListType_Fragment = {
  __typename?: "IpSubscriptionListType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_IpSubscriptionListType_Fragment" };

type BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment = {
  __typename?: "IrbSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L2VPNSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L3VPNSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment = {
  __typename?: "LightPathSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_LightPathSubscriptionType_Fragment = {
  __typename?: "LightPathSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_LightPathSubscriptionType_Fragment" };

type BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment = {
  __typename?: "MscSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment = {
  __typename?: "ServicePortSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment = {
  __typename?: "WiredSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_WiredSubscriptionType_Fragment = {
  __typename?: "WiredSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_WiredSubscriptionType_Fragment" };

type BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment = {
  __typename?: "WirelessSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment" };

type BaseSubscriptionFragment_WirelessSubscriptionType_Fragment = {
  __typename?: "WirelessSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
} & { " $fragmentName"?: "BaseSubscriptionFragment_WirelessSubscriptionType_Fragment" };

export type BaseSubscriptionFragmentFragment =
  | BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_FirewallSubscriptionType_Fragment
  | BaseSubscriptionFragment_IpPrefixSubscriptionType_Fragment
  | BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_IpSubscriptionListType_Fragment
  | BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_LightPathSubscriptionType_Fragment
  | BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WiredSubscriptionType_Fragment
  | BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WirelessSubscriptionType_Fragment;

export type LinkedServicesFragmentFragment = {
  __typename?: "ServiceType";
  insync: boolean;
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  sapSubscriptionInstanceId?: string | null;
  customerId: string;
  status: string;
  description: string;
  customerDescription: string;
  organisation?: string | null;
  speed: number;
  percentage: number;
  vlanrange?: string | null;
  portSpeed?: number | null;
  amountReserved: number;
  product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  services?: Array<{
    __typename?: "ServiceType";
    description: string;
    percentage: number;
    speed: number;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  }> | null;
} & { " $fragmentName"?: "LinkedServicesFragmentFragment" };

export type MinifiedLinkedServicesFragmentFragment = {
  __typename?: "ServiceType";
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  sapSubscriptionInstanceId?: string | null;
  description: string;
  customerDescription: string;
  status: string;
  speed: number;
  percentage: number;
  vlanrange?: string | null;
  product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
} & { " $fragmentName"?: "MinifiedLinkedServicesFragmentFragment" };

type SubscriptionListBaseFragment_AggspSubscriptionDetailsType_Fragment = {
  __typename?: "AggspSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_AggspSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_FirewallSubscriptionDetailsType_Fragment = {
  __typename?: "FirewallSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_FirewallSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment = {
  __typename?: "FirewallSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment" };

type SubscriptionListBaseFragment_IpPrefixSubscriptionType_Fragment = {
  __typename?: "IpPrefixSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_IpPrefixSubscriptionType_Fragment" };

type SubscriptionListBaseFragment_IpSubscriptionDetailsType_Fragment = {
  __typename?: "IpSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_IpSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_IpSubscriptionListType_Fragment = {
  __typename?: "IpSubscriptionListType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_IpSubscriptionListType_Fragment" };

type SubscriptionListBaseFragment_IrbSubscriptionDetailsType_Fragment = {
  __typename?: "IrbSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_IrbSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_L2VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L2VPNSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_L2VpnSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_L3VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L3VPNSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_L3VpnSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_LightPathSubscriptionDetailsType_Fragment = {
  __typename?: "LightPathSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_LightPathSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment = {
  __typename?: "LightPathSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment" };

type SubscriptionListBaseFragment_MscSubscriptionDetailsType_Fragment = {
  __typename?: "MscSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_MscSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_ServicePortSubscriptionDetailsType_Fragment = {
  __typename?: "ServicePortSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_ServicePortSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_WiredSubscriptionDetailsType_Fragment = {
  __typename?: "WiredSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_WiredSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_WiredSubscriptionType_Fragment = {
  __typename?: "WiredSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_WiredSubscriptionType_Fragment" };

type SubscriptionListBaseFragment_WirelessSubscriptionDetailsType_Fragment = {
  __typename?: "WirelessSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_WirelessSubscriptionDetailsType_Fragment" };

type SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment = {
  __typename?: "WirelessSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment" };

export type SubscriptionListBaseFragmentFragment =
  | SubscriptionListBaseFragment_AggspSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_FirewallSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment
  | SubscriptionListBaseFragment_IpPrefixSubscriptionType_Fragment
  | SubscriptionListBaseFragment_IpSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_IpSubscriptionListType_Fragment
  | SubscriptionListBaseFragment_IrbSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_L2VpnSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_L3VpnSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_LightPathSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment
  | SubscriptionListBaseFragment_MscSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_ServicePortSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WiredSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WiredSubscriptionType_Fragment
  | SubscriptionListBaseFragment_WirelessSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment;

export type L2VpnListBaseFragmentFragment = {
  __typename?: "L2VpnSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "L2VpnListBaseFragmentFragment" };

export type L3VpnListBaseFragmentFragment = {
  __typename?: "L3VpnSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "L3VpnListBaseFragmentFragment" };

export type PortListBaseFragmentFragment = {
  __typename?: "ServicePortSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "PortListBaseFragmentFragment" };

export type ServiceTypeFragmentFragment = {
  __typename?: "ServiceType";
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  speed: number;
  percentage: number;
  description: string;
  product: { __typename?: "ProductType"; type: string; tag: string };
} & { " $fragmentName"?: "ServiceTypeFragmentFragment" };

export type PortServiceTypeFragmentFragment = {
  __typename?: "PortServiceType";
  subscriptionId: string;
  productType: string;
  speed: number;
  percentage: number;
  description: string;
} & { " $fragmentName"?: "PortServiceTypeFragmentFragment" };

export type PortAccessCustomerListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type PortAccessCustomerListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "ServicePortSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename?: "ServicePortSubscriptionType";
        portSpeed: number;
        portMode: string;
        speed?: string | null;
        amountReserved: number;
        services: Array<
          { __typename?: "ServiceType" } & {
            " $fragmentRefs"?: { ServiceTypeFragmentFragment: ServiceTypeFragmentFragment };
          }
        >;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            city?: string | null;
            number?: string | null;
            street?: string | null;
            addition?: string | null;
          } | null;
        }>;
      } & { " $fragmentRefs"?: { PortListBaseFragmentFragment: PortListBaseFragmentFragment } }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type PortCustomerListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type PortCustomerListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "ServicePortSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename?: "ServicePortSubscriptionType";
        portSpeed: number;
        portMode: string;
        speed?: string | null;
        amountReserved: number;
        usedVlans: Array<string>;
        services: Array<
          { __typename?: "ServiceType" } & {
            " $fragmentRefs"?: { ServiceTypeFragmentFragment: ServiceTypeFragmentFragment };
          }
        >;
        address?: { __typename?: "AddressType"; city?: string | null; street?: string | null } | null;
      } & { " $fragmentRefs"?: { PortListBaseFragmentFragment: PortListBaseFragmentFragment } }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type L3vpnListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type L3vpnListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "L3VpnSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename: "L3VpnSubscriptionType";
        firewallEnabled: boolean;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            city?: string | null;
            number?: string | null;
            street?: string | null;
            addition?: string | null;
          } | null;
        }>;
      } & { " $fragmentRefs"?: { L3VpnListBaseFragmentFragment: L3VpnListBaseFragmentFragment } }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type L2vpnListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type L2vpnListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "L2VpnSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename: "L2VpnSubscriptionType";
        firewallEnabled: boolean;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            city?: string | null;
            number?: string | null;
            street?: string | null;
            addition?: string | null;
          } | null;
        }>;
      } & { " $fragmentRefs"?: { L2VpnListBaseFragmentFragment: L2VpnListBaseFragmentFragment } }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type LightPathListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type LightPathListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "LightPathSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename: "LightPathSubscriptionType";
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            city?: string | null;
            number?: string | null;
            street?: string | null;
            addition?: string | null;
          } | null;
        }>;
        services: Array<
          { __typename?: "PortServiceType" } & {
            " $fragmentRefs"?: { PortServiceTypeFragmentFragment: PortServiceTypeFragmentFragment };
          }
        >;
      } & {
        " $fragmentRefs"?: {
          SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment: SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment;
        };
      }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type IpPrefixesListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type IpPrefixesListQueryQuery = {
  __typename?: "PrivateQuery";
  ipPrefixList: {
    __typename?: "IpPrefixSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "IpPrefixSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
      startDate: number;
      customerDescription: string;
      insync: boolean;
      subscriptionType: "IpPrefixSubscriptionType";
      ipPrefix?: { __typename?: "IpPrefixType"; afi: string; state: number; prefix: string } | null;
      ipSubscriptions: Array<{
        __typename?: "IPSubscriptionListItemType";
        subscriptionId: string;
        customerId: string;
        description: string;
        customerDescription: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
      availableIpSubscriptions: Array<{
        __typename?: "IPSubscriptionListItemType";
        subscriptionId: string;
        customerId: string;
        description: string;
        customerDescription: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
    }>;
  };
};

export type WirelessSubscriptionListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WirelessSubscriptionListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WirelessSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename: "WirelessSubscriptionType";
        name?: string | null;
        supplier: string;
        sensorPresent: boolean;
        jiraLocationId?: string | null;
        location: { __typename?: "WirelessLocationActivityType"; city?: string | null };
      } & {
        " $fragmentRefs"?: {
          SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment: SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment;
        };
      }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type WiredSubscriptionListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WiredSubscriptionListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WiredSubscriptionTypeConnectionV2";
    page: Array<
      {
        __typename: "WiredSubscriptionType";
        name?: string | null;
        monitoringEnabled: boolean;
        customCustomerAbbreviation?: string | null;
      } & {
        " $fragmentRefs"?: {
          SubscriptionListBaseFragment_WiredSubscriptionType_Fragment: SubscriptionListBaseFragment_WiredSubscriptionType_Fragment;
        };
      }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type IpListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type IpListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "IpSubscriptionListTypeConnectionV2";
    page: Array<
      {
        __typename?: "IpSubscriptionListType";
        protection: string;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            city?: string | null;
            number?: string | null;
            street?: string | null;
            addition?: string | null;
          } | null;
        }>;
      } & {
        " $fragmentRefs"?: {
          SubscriptionListBaseFragment_IpSubscriptionListType_Fragment: SubscriptionListBaseFragment_IpSubscriptionListType_Fragment;
        };
      }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type FirewallListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type FirewallListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "FirewallSubscriptionTypeConnectionV2";
    page: Array<
      { __typename?: "FirewallSubscriptionType" } & {
        " $fragmentRefs"?: {
          SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment: SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment;
        };
      }
    >;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type BaseSubscriptionsOfTypeQueryQueryVariables = Exact<{
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type BaseSubscriptionsOfTypeQueryQuery = {
  __typename?: "PrivateQuery";
  customerSubscriptions: Array<{
    __typename?: "SubscriptionType";
    subscriptionId: string;
    description: string;
    customerDescription: string;
    product: { __typename?: "ProductType"; type: string };
  }>;
};

export type SurfCertDdosItemsQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type SurfCertDdosItemsQuery = {
  __typename?: "PrivateQuery";
  surfCertList: {
    __typename?: "SurfCertTypeConnectionV2";
    page: Array<{
      __typename?: "SurfCertType";
      customerDescription: string;
      description: string;
      productType: string;
      status: string;
      subscriptionId: string;
      surfcertFilterEnabled: boolean;
    }>;
  };
};

export type WirelessListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WirelessListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WirelessSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "WirelessSubscriptionType";
      subscriptionId: string;
      description: string;
      customerDescription: string;
      location: { __typename?: "WirelessLocationActivityType"; city?: string | null };
    }>;
  };
};

export type FirewallSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type FirewallSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  firewallDetails: {
    __typename?: "FirewallSubscriptionDetailsType";
    availabilityZone?: string | null;
    customerAsn?: any | null;
    domain: string;
    firewallEnabled: boolean;
    fwAsn: any;
    protection: string;
    serviceSpeed: number;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    ipGateway?: {
      __typename?: "IpGatewayType";
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      serviceSpeed: number;
      subscriptionInstanceId?: string | null;
      surfcertFilter: string;
      ipPrefixes: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
    } | null;
    l3Endpoints: Array<{
      __typename?: "L3EndpointType";
      subscriptionId: string;
      customerId: string;
      description: string;
      organisation?: string | null;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      tags: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    l2Endpoints: Array<{
      __typename?: "L2EndpointType";
      subscriptionId: string;
      customerId: string;
      description: string;
      ipv4PtpPrefixes: Array<number>;
      ipv6PtpPrefixes: Array<number>;
      organisation?: string | null;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      tags: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment;
    };
  };
};

export type IpSapPortDataFragment = {
  __typename?: "IPServiceAttachPointType";
  port?: {
    __typename?: "ServicePortSubscriptionType";
    amountReserved: number;
    description: string;
    domain: string;
    locationDescription?: string | null;
    portMode: string;
    portSpeed: number;
    speed?: string | null;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
    services: Array<
      { __typename?: "ServiceType" } & {
        " $fragmentRefs"?: { MinifiedLinkedServicesFragmentFragment: MinifiedLinkedServicesFragmentFragment };
      }
    >;
    locations: Array<{
      __typename?: "LocationType";
      address?: {
        __typename?: "AddressType";
        addition?: string | null;
        city?: string | null;
        countryCode?: string | null;
        extraAddressLine?: string | null;
        number?: string | null;
        street?: string | null;
        zipcode?: string | null;
      } | null;
    }>;
  } | null;
} & { " $fragmentName"?: "IpSapPortDataFragment" };

export type IpSapDataFragment = ({
  __typename?: "IPServiceAttachPointType";
  subscriptionInstanceId: string;
  bfd?: boolean | null;
  bfdMinimumInterval?: number | null;
  bfdMultiplier?: number | null;
  bgpExportPolicy?: string | null;
  bgpHashAlgorithm?: string | null;
  bgpPassword?: string | null;
  bgpSessionPriority?: string | null;
  gracefulRestart?: boolean | null;
  ipv4Mtu?: number | null;
  ipv6Mtu?: number | null;
  vlanrange: string;
  ipPrefixes: Array<string>;
  ipv4PointToPointPrefix?: {
    __typename?: "IpPointToPointPrefixType";
    clientFQDN: string;
    clientIpAddress: string;
    network: string;
    surfFQDN: string;
    surfIpAddress: string;
  } | null;
  ipv6PointToPointPrefix?: {
    __typename?: "IpPointToPointPrefixType";
    clientFQDN: string;
    clientIpAddress: string;
    network: string;
    surfFQDN: string;
    surfIpAddress: string;
  } | null;
} & { " $fragmentRefs"?: { IpSapPortDataFragment: IpSapPortDataFragment } }) & {
  " $fragmentName"?: "IpSapDataFragment";
};

export type IpBgpSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IpBgpSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  ipBgpDetails: {
    __typename?: "IpSubscriptionDetailsType";
    domain: string;
    firewallEnabled?: boolean | null;
    ipRoutingType: string;
    protection: string;
    serviceSpeed: number;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    ipss: { __typename?: "IpServiceSettingsType"; surfcertFilter: string; asn?: number | null };
    saps: Array<
      { __typename?: "IPServiceAttachPointType" } & { " $fragmentRefs"?: { IpSapDataFragment: IpSapDataFragment } }
    >;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        topologyObjectType: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        vlanrange?: string | null;
        customerDescription: string;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment;
    };
  };
};

export type IpStaticSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IpStaticSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  ipStaticDetails: {
    __typename?: "IpSubscriptionDetailsType";
    serviceSpeed: number;
    firewallEnabled?: boolean | null;
    protection: string;
    domain: string;
    ipRoutingType: string;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    ipss: { __typename?: "IpServiceSettingsType"; surfcertFilter: string; asn?: number | null };
    saps: Array<
      { __typename?: "IPServiceAttachPointType" } & { " $fragmentRefs"?: { IpSapDataFragment: IpSapDataFragment } }
    >;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment;
    };
  };
};

export type IrbSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IrbSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  irbDetails: {
    __typename?: "IrbSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    portSubscription?: string | null;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services: Array<
      { __typename?: "ServiceType" } & {
        " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
      }
    >;
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment;
    };
  };
};

export type L2vpnSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type L2vpnSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  l2vpnDetails: {
    __typename?: "L2VPNSubscriptionDetailsType";
    firewallEnabled: boolean;
    domain: string;
    serviceSpeed: number;
    protection: string;
    speedPolicer: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    circuits: Array<{
      __typename?: "L2VPNCircuitType";
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          portMode: string;
          subscriptionId: string;
          tags: Array<string>;
          speed?: string | null;
          customerDescription: string;
          services: Array<{ __typename?: "ServiceType"; vlanrange?: string | null; insync: boolean }>;
        } | null;
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          street?: string | null;
          number?: string | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    saps: Array<{
      __typename?: "ServiceAttachPointType";
      subscriptionInstanceId: string;
      name: string;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        subscriptionId: string;
        description: string;
        domain: string;
        portMode: string;
        portSpeed: number;
        amountReserved: number;
        speed?: string | null;
        status: string;
        tags: Array<string>;
        customerDescription: string;
        customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
        product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
        services: Array<
          { __typename?: "ServiceType" } & {
            " $fragmentRefs"?: { MinifiedLinkedServicesFragmentFragment: MinifiedLinkedServicesFragmentFragment };
          }
        >;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        }>;
      } | null;
    }>;
    esis: Array<{
      __typename?: "EthernetSegmentIdentifierType";
      segmentId?: number | null;
      firewallInterconnect?: {
        __typename?: "L2InterconnectType";
        firewallSubscriptionId?: string | null;
        subscriptionInstanceId?: string | null;
      } | null;
      endpoints?: Array<{
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        organisation?: string | null;
        name: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          subscriptionId: string;
          description: string;
          amountReserved: number;
          portSpeed: number;
          tags: Array<string>;
          customerDescription: string;
          usedVlans: Array<string>;
          customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
          locations: Array<{
            __typename?: "LocationType";
            address?: {
              __typename?: "AddressType";
              addition?: string | null;
              city?: string | null;
              number?: string | null;
              street?: string | null;
            } | null;
          }>;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
          services: Array<
            { __typename?: "ServiceType" } & {
              " $fragmentRefs"?: { MinifiedLinkedServicesFragmentFragment: MinifiedLinkedServicesFragmentFragment };
            }
          >;
          product: { __typename?: "ProductType"; id: string; type: string; tag: string };
        } | null;
      }> | null;
    }>;
    firewallInterconnects: Array<{
      __typename?: "L2InterconnectType";
      availabilityZone?: string | null;
      description: string;
      firewallSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      organisation?: string | null;
      customerId?: string | null;
      endpoints?: Array<{ __typename?: "ServiceAttachPointType"; subscriptionInstanceId: string }> | null;
    }>;
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment;
    };
  };
};

export type L3vpnSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type L3vpnSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  l3vpnDetails: {
    __typename?: "L3VPNSubscriptionDetailsType";
    firewallEnabled: boolean;
    domain: string;
    insync: boolean;
    serviceSpeed: number;
    protection: string;
    speedPolicer: boolean;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    circuits: Array<{
      __typename?: "L3VPNCircuitType";
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          customerDescription: string;
          portMode: string;
          subscriptionId: string;
          tags: Array<string>;
          speed?: string | null;
          services: Array<{ __typename?: "ServiceType"; vlanrange?: string | null; insync: boolean }>;
        } | null;
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          street?: string | null;
          number?: string | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    l3vpnss: { __typename?: "L3VPNServiceSettingsType"; l3vpnAsn: number };
    l3vpnsapss: Array<{
      __typename?: "L3VPNSAPServiceSettingsType";
      subscriptionInstanceId: string;
      name: string;
      bfd?: boolean | null;
      bfdMinimumInterval?: number | null;
      bfdMultiplier?: number | null;
      bgpPassword?: string | null;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      bgpMetric?: string | null;
      ipv4Address?: string | null;
      ipv4MaxPrefix?: number | null;
      ipv6Address?: string | null;
      ipv4RemoteAddress?: string | null;
      ipv6MaxPrefix?: number | null;
      ipv6RemoteAddress?: string | null;
      sap: {
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          description: string;
          domain: string;
          portMode: string;
          portSpeed: number;
          amountReserved: number;
          speed?: string | null;
          status: string;
          subscriptionId: string;
          tags: Array<string>;
          customerDescription: string;
          product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
          customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
          services: Array<
            { __typename?: "ServiceType" } & {
              " $fragmentRefs"?: { MinifiedLinkedServicesFragmentFragment: MinifiedLinkedServicesFragmentFragment };
            }
          >;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
          locations: Array<{
            __typename?: "LocationType";
            address?: {
              __typename?: "AddressType";
              addition?: string | null;
              city?: string | null;
              countryCode?: string | null;
              extraAddressLine?: string | null;
              number?: string | null;
              street?: string | null;
              zipcode?: string | null;
            } | null;
          }>;
        } | null;
      };
    }>;
    firewallInterconnects: Array<{
      __typename?: "L3FwInterconnectType";
      availabilityZone: string;
      firewallAsn: string;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      ipv4Prefix?: any | null;
      ipv6Prefix?: any | null;
      ipv4MaxPrefix?: number | null;
      ipv6MaxPrefix?: number | null;
      ipv4AddressFirewall?: any | null;
      ipv6AddressFirewall?: any | null;
      firewallSubscriptionId: string;
      subscriptionInstanceId: string;
      organisation?: string | null;
      customerId: string;
      customerDescription: string;
      description: string;
      saps: Array<{
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        name: string;
        tag: string;
        organisation?: string | null;
        vlanrange: string;
        address?: {
          __typename?: "AddressType";
          street?: string | null;
          number?: string | null;
          city?: string | null;
        } | null;
      }>;
    }>;
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment;
    };
  };
};

export type LightPathSubscriptionDetailsFragmentFragment = ({
  __typename?: "LightPathSubscriptionDetailsType";
  domain: string;
  protection: string;
  serviceId?: string | null;
  serviceSpeed: number;
  speedPolicer: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  saps: Array<{
    __typename?: "ServiceAttachPointType";
    name: string;
    organisation?: string | null;
    subscriptionInstanceId: string;
    tag: string;
    vlanrange: string;
  }>;
  circuits: Array<{
    __typename?: "LightPathCircuitType";
    name: string;
    remotePortShutdown?: boolean | null;
    serviceId?: string | null;
    serviceSpeed?: number | null;
    subscriptionInstanceId: string;
    tag: string;
    endpoints: Array<{
      __typename?: "ServiceAttachPointType";
      name: string;
      organisation?: string | null;
      subscriptionInstanceId: string;
      tag: string;
      vlanrange: string;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        amountReserved: number;
        customerDescription: string;
        description: string;
        domain: string;
        portMode: string;
        portSpeed: number;
        speed?: string | null;
        status: string;
        subscriptionId: string;
        tags: Array<string>;
        usedVlans: Array<string>;
        customer?: { __typename?: "CustomerType"; customerId: string } | null;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
        services: Array<
          { __typename?: "ServiceType" } & {
            " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
          }
        >;
        address?: {
          __typename?: "AddressType";
          addition?: string | null;
          city?: string | null;
          countryCode?: string | null;
          extraAddressLine?: string | null;
          number?: string | null;
          street?: string | null;
          zipcode?: string | null;
        } | null;
      } | null;
    }>;
  }>;
  topology: Array<
    Array<{
      __typename?: "TopologyObjectType";
      customerDescription: string;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId: string;
      topologyObjectType: string;
      vlanrange?: string | null;
      product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
    }>
  >;
} & {
  " $fragmentRefs"?: {
    BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment;
  };
}) & { " $fragmentName"?: "LightPathSubscriptionDetailsFragmentFragment" };

export type LightpathSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type LightpathSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  lpDetails: { __typename?: "LightPathSubscriptionDetailsType" } & {
    " $fragmentRefs"?: { LightPathSubscriptionDetailsFragmentFragment: LightPathSubscriptionDetailsFragmentFragment };
  };
};

export type LightpathRedundantSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type LightpathRedundantSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  lrDetails: { __typename?: "LightPathSubscriptionDetailsType" } & {
    " $fragmentRefs"?: { LightPathSubscriptionDetailsFragmentFragment: LightPathSubscriptionDetailsFragmentFragment };
  };
};

export type LinkMemberFragmentFragment = {
  __typename?: "LinkMemberDetailsType";
  subscriptionId: string;
  customerId: string;
  description: string;
  organisation?: string | null;
  customerDescription: string;
  vlanrange?: string | null;
  patchPosition?: string | null;
  ieeeInterfaceType?: string | null;
  portSpeed: number;
  amountReserved: number;
  tags: Array<string>;
  product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  services: Array<
    { __typename?: "ServiceType" } & {
      " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
    }
  >;
} & { " $fragmentName"?: "LinkMemberFragmentFragment" };

export type AggspSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type AggspSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  aggspDetails: {
    __typename?: "AggspSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    portSubscription?: string | null;
    linkMemberSubscriptions: Array<
      { __typename?: "LinkMemberDetailsType" } & {
        " $fragmentRefs"?: { LinkMemberFragmentFragment: LinkMemberFragmentFragment };
      }
    >;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services?: Array<
      { __typename?: "ServiceType" } & {
        " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
      }
    > | null;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment;
    };
  };
};

export type MscSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type MscSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  mscDetails: {
    __typename?: "MscSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    serviceTag?: number | null;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    portSubscription?: {
      __typename?: "MscPortSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
    } | null;
    services: Array<
      { __typename?: "ServiceType" } & {
        " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
      }
    >;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment;
    };
  };
};

export type PortSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type PortSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  servicePortDetails: {
    __typename: "ServicePortSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portMode?: string | null;
    autoNegotiation?: boolean | null;
    patchPosition?: string | null;
    fiberType?: string | null;
    connectorType?: string | null;
    ieeeInterfaceType?: string | null;
    domain: string;
    amountReserved: number;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services?: Array<
      { __typename?: "ServiceType" } & {
        " $fragmentRefs"?: { LinkedServicesFragmentFragment: LinkedServicesFragmentFragment };
      }
    > | null;
    aggregateParent?: {
      __typename?: "AggregateParentType";
      subscriptionId: string;
      customerDescription: string;
    } | null;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment;
    };
  };
};

export type WiredSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WiredSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  wiredDetails: {
    __typename?: "WiredSubscriptionDetailsType";
    monitoringEnabled: boolean;
    customCustomerAbbreviation?: string | null;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment;
    };
  };
};

export type WirelessSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WirelessSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  wirelessDetails: {
    __typename?: "WirelessSubscriptionDetailsType";
    sensorPresent: boolean;
    supplier: string;
    location?: {
      __typename?: "WirelessLocationDetailsType";
      city?: string | null;
      country?: string | null;
      address?: string | null;
      accessPoints: Array<{
        __typename?: "AccessPointType";
        brand?: string | null;
        model?: string | null;
        supplier?: string | null;
        ciStatus?: string | null;
      }>;
    } | null;
    tickets: Array<{
      __typename?: "WirelessTicketType";
      ticketId: string;
      summary?: string | null;
      created: any;
      locations: Array<string>;
      status: { __typename?: "WirelessTicketStatusType"; id: number; name: string };
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  } & {
    " $fragmentRefs"?: {
      BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment: BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment;
    };
  };
};

export type WirelessOrganisationTicketsQueryVariables = Exact<{
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WirelessOrganisationTicketsQuery = {
  __typename?: "PrivateQuery";
  wirelessOrganisationTickets: Array<{
    __typename?: "WirelessTicketType";
    ticketId: string;
    summary?: string | null;
    created: any;
    locations: Array<string>;
    status: { __typename?: "WirelessTicketStatusType"; id: number; name: string };
  }>;
};

export const CimNotificationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimNotification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "impact" } },
          { kind: "Field", name: { kind: "Name", value: "planDate" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "urgency" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CimNotificationFragment, unknown>;
export const CimAffectedSubscriptionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimAffectedSubscriptions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "affectedSubscriptions" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: { kind: "Variable", name: { kind: "Name", value: "includeAffectedSubscriptions" } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "impactType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CimAffectedSubscriptionsFragment, unknown>;
export const PaginationInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaginationInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PageInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "totalItems" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaginationInfoFragment, unknown>;
export const SubscriptionListBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionListBaseFragmentFragment, unknown>;
export const L2VpnListBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "L2VpnListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "L2VpnSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L2VpnListBaseFragmentFragment, unknown>;
export const L3VpnListBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "L3VpnListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "L3VpnSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L3VpnListBaseFragmentFragment, unknown>;
export const PortListBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PortListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServicePortSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortListBaseFragmentFragment, unknown>;
export const ServiceTypeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceTypeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceTypeFragmentFragment, unknown>;
export const PortServiceTypeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PortServiceTypeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PortServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortServiceTypeFragmentFragment, unknown>;
export const MinifiedLinkedServicesFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MinifiedLinkedServicesFragmentFragment, unknown>;
export const IpSapPortDataFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapPortData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "port" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MinifiedLinkedServicesFragment" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addition" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                            { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                            { kind: "Field", name: { kind: "Name", value: "number" } },
                            { kind: "Field", name: { kind: "Name", value: "street" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSapPortDataFragment, unknown>;
export const IpSapDataFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IpSapPortData" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "bfd" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMinimumInterval" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMultiplier" } },
          { kind: "Field", name: { kind: "Name", value: "bgpExportPolicy" } },
          { kind: "Field", name: { kind: "Name", value: "bgpHashAlgorithm" } },
          { kind: "Field", name: { kind: "Name", value: "bgpPassword" } },
          { kind: "Field", name: { kind: "Name", value: "bgpSessionPriority" } },
          { kind: "Field", name: { kind: "Name", value: "gracefulRestart" } },
          { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "ipPrefixes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv4PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv6PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapPortData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "port" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MinifiedLinkedServicesFragment" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addition" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                            { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                            { kind: "Field", name: { kind: "Name", value: "number" } },
                            { kind: "Field", name: { kind: "Name", value: "street" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpSapDataFragment, unknown>;
export const BaseSubscriptionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseSubscriptionFragmentFragment, unknown>;
export const LinkedServicesFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkedServicesFragmentFragment, unknown>;
export const LightPathSubscriptionDetailsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LightPathSubscriptionDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LightPathSubscriptionDetailsType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
          { kind: "Field", name: { kind: "Name", value: "domain" } },
          { kind: "Field", name: { kind: "Name", value: "protection" } },
          { kind: "Field", name: { kind: "Name", value: "serviceId" } },
          { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "speedPolicer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "saps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "organisation" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "circuits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "remotePortShutdown" } },
                { kind: "Field", name: { kind: "Name", value: "serviceId" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endpoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "port" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "portMode" } },
                            { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                            { kind: "Field", name: { kind: "Name", value: "speed" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "usedVlans" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "customerId" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "services" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topology" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LightPathSubscriptionDetailsFragmentFragment, unknown>;
export const LinkMemberFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkMemberFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LinkMemberDetailsType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "patchPosition" } },
          { kind: "Field", name: { kind: "Name", value: "ieeeInterfaceType" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkMemberFragmentFragment, unknown>;
export const GetAirtScansDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAirtScans" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchFilter" } },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "20" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "0" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "AirtSort" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "airtScans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: { kind: "Variable", name: { kind: "Name", value: "sort" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "importedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "modelVersion" } },
                            { kind: "Field", name: { kind: "Name", value: "classification" } },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                            { kind: "Field", name: { kind: "Name", value: "extra" } },
                            { kind: "Field", name: { kind: "Name", value: "feed" } },
                            { kind: "Field", name: { kind: "Name", value: "malware" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "time" } },
                            { kind: "Field", name: { kind: "Name", value: "protocol" } },
                            { kind: "Field", name: { kind: "Name", value: "numberOfHits" } },
                            { kind: "Field", name: { kind: "Name", value: "lastSeen" } },
                            { kind: "Field", name: { kind: "Name", value: "firstSeen" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaginationInfo" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaginationInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PageInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "totalItems" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAirtScansQuery, GetAirtScansQueryVariables>;
export const GetAirtScansClassificationProtocolDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAirtScansClassificationProtocol" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchFilter" } },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "airtScans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "999999" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "classification" } },
                            { kind: "Field", name: { kind: "Name", value: "protocol" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAirtScansClassificationProtocolQuery, GetAirtScansClassificationProtocolQueryVariables>;
export const GetAirtScansCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAirtScansCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SearchFilter" } },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "20" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "0" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "airtScans" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "classification" } },
                            { kind: "Field", name: { kind: "Name", value: "protocol" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaginationInfo" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaginationInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PageInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "totalItems" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAirtScansCountQuery, GetAirtScansCountQueryVariables>;
export const CertMitigationPrefixesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CertMitigationPrefixes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ipPrefixDdos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "autoMitigation" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "insync" } },
                      { kind: "Field", name: { kind: "Name", value: "prefix" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "version" } },
                      { kind: "Field", name: { kind: "Name", value: "afi" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CertMitigationPrefixesQuery, CertMitigationPrefixesQueryVariables>;
export const CimNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CimNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "NotificationFilter" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "includeAffectedSubscriptions" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          defaultValue: { kind: "BooleanValue", value: true },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "cimNotification" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "cimAffectedSubscriptions" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimNotification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "impact" } },
          { kind: "Field", name: { kind: "Name", value: "planDate" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "urgency" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimAffectedSubscriptions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "affectedSubscriptions" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: { kind: "Variable", name: { kind: "Name", value: "includeAffectedSubscriptions" } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "impactType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CimNotificationsQuery, CimNotificationsQueryVariables>;
export const CimNotificationsSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CimNotificationsSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "NotificationFilter" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "cimNotification" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimNotification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "impact" } },
          { kind: "Field", name: { kind: "Name", value: "planDate" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "urgency" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CimNotificationsSubscriptionQuery, CimNotificationsSubscriptionQueryVariables>;
export const CimMajorDisruptionNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CimMajorDisruptionNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "MajorDisruptionNotificationFilter" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "majorDisruptionNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "cimNotification" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "cimNotification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "impact" } },
          { kind: "Field", name: { kind: "Name", value: "planDate" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "urgency" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CimMajorDisruptionNotificationsQuery, CimMajorDisruptionNotificationsQueryVariables>;
export const CustomerWithMinimalImpactNotificationQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CustomerWithMinimalImpactNotificationQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "products" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerSubscriptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "products" },
                value: { kind: "Variable", name: { kind: "Name", value: "products" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerWithMinimalImpactNotificationQueryQuery,
  CustomerWithMinimalImpactNotificationQueryQueryVariables
>;
export const GetDnsFirewallDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDnsFirewall" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DnsFirewallSearchFilter" } },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "20" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "0" },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DnsFirewallSort" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dnsFirewallLogs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: { kind: "Variable", name: { kind: "Name", value: "sort" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "customerId" } },
                            { kind: "Field", name: { kind: "Name", value: "ipAddress" } },
                            { kind: "Field", name: { kind: "Name", value: "rpzFeed" } },
                            { kind: "Field", name: { kind: "Name", value: "hit" } },
                            { kind: "Field", name: { kind: "Name", value: "recordedAt" } },
                            { kind: "Field", name: { kind: "Name", value: "resolver" } },
                            { kind: "Field", name: { kind: "Name", value: "action" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PaginationInfo" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaginationInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PageInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "totalItems" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDnsFirewallQuery, GetDnsFirewallQueryVariables>;
export const PortAccessCustomerListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PortAccessCustomerListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "portList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PortListBaseFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                      { kind: "Field", name: { kind: "Name", value: "portMode" } },
                      { kind: "Field", name: { kind: "Name", value: "speed" } },
                      { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "services" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceTypeFragment" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PortListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServicePortSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceTypeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortAccessCustomerListQueryQuery, PortAccessCustomerListQueryQueryVariables>;
export const PortCustomerListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PortCustomerListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "portList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "customerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PortListBaseFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                      { kind: "Field", name: { kind: "Name", value: "portMode" } },
                      { kind: "Field", name: { kind: "Name", value: "speed" } },
                      { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                      { kind: "Field", name: { kind: "Name", value: "usedVlans" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "services" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "ServiceTypeFragment" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "street" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PortListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServicePortSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ServiceTypeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortCustomerListQueryQuery, PortCustomerListQueryQueryVariables>;
export const L3vpnListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "L3vpnListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "l3vpnList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "L3VpnListBaseFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "L3VpnListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "L3VpnSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L3vpnListQueryQuery, L3vpnListQueryQueryVariables>;
export const L2vpnListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "L2vpnListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "l2vpnList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "L2VpnListBaseFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "L2VpnListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "L2VpnSubscriptionType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L2vpnListQueryQuery, L2vpnListQueryQueryVariables>;
export const LightPathListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LightPathListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "evpnPtpList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "SubscriptionListBaseFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "services" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "FragmentSpread", name: { kind: "Name", value: "PortServiceTypeFragment" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PortServiceTypeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PortServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LightPathListQueryQuery, LightPathListQueryQueryVariables>;
export const IpPrefixesListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IpPrefixesListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ipPrefixList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "EnumValue", value: "ACTIVE" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "subscriptionType" },
                        name: { kind: "Name", value: "__typename" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "insync" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ipPrefix" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "afi" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "prefix" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ipSubscriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "customerId" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableIpSubscriptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "customerId" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpPrefixesListQueryQuery, IpPrefixesListQueryQueryVariables>;
export const WirelessSubscriptionListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WirelessSubscriptionListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "wirelessList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "SubscriptionListBaseFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "supplier" } },
                      { kind: "Field", name: { kind: "Name", value: "sensorPresent" } },
                      { kind: "Field", name: { kind: "Name", value: "jiraLocationId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "city" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WirelessSubscriptionListQueryQuery, WirelessSubscriptionListQueryQueryVariables>;
export const WiredSubscriptionListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WiredSubscriptionListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "wiredList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "SubscriptionListBaseFragment" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "monitoringEnabled" } },
                      { kind: "Field", name: { kind: "Name", value: "customCustomerAbbreviation" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WiredSubscriptionListQueryQuery, WiredSubscriptionListQueryQueryVariables>;
export const IpListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IpListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "ipList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "SubscriptionListBaseFragment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "protection" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpListQueryQuery, IpListQueryQueryVariables>;
export const FirewallListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FirewallListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "firewallList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionId" },
                      value: { kind: "EnumValue", value: "ASC" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "SubscriptionListBaseFragment" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalItems" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubscriptionListBaseFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "healthSubscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FirewallListQueryQuery, FirewallListQueryQueryVariables>;
export const BaseSubscriptionsOfTypeQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BaseSubscriptionsOfTypeQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "products" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "statuses" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerSubscriptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "customerId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "products" },
                value: { kind: "Variable", name: { kind: "Name", value: "products" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: { kind: "Variable", name: { kind: "Name", value: "statuses" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseSubscriptionsOfTypeQueryQuery, BaseSubscriptionsOfTypeQueryQueryVariables>;
export const SurfCertDdosItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SurfCertDdosItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "surfCertList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "productType" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "surfcertFilterEnabled" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SurfCertDdosItemsQuery, SurfCertDdosItemsQueryVariables>;
export const WirelessListQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WirelessListQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "customer" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "subscriptions" },
            name: { kind: "Name", value: "wirelessList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accessCustomerId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "customer" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "page" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "city" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WirelessListQueryQuery, WirelessListQueryQueryVariables>;
export const FirewallSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FirewallSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "firewallDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topology" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "availabilityZone" } },
                { kind: "Field", name: { kind: "Name", value: "customerAsn" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "fwAsn" } },
                { kind: "Field", name: { kind: "Name", value: "protection" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ipGateway" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "surfcertFilter" } },
                      { kind: "Field", name: { kind: "Name", value: "ipPrefixes" } },
                      { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceIds" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "l3Endpoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceIds" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "l2Endpoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4PtpPrefixes" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6PtpPrefixes" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceIds" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FirewallSubscriptionDetailsQuery, FirewallSubscriptionDetailsQueryVariables>;
export const IpBgpSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IpBgpSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ipBgpDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "ipRoutingType" } },
                { kind: "Field", name: { kind: "Name", value: "protection" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ipss" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "surfcertFilter" } },
                      { kind: "Field", name: { kind: "Name", value: "asn" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saps" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IpSapData" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topology" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapPortData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "port" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MinifiedLinkedServicesFragment" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addition" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                            { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                            { kind: "Field", name: { kind: "Name", value: "number" } },
                            { kind: "Field", name: { kind: "Name", value: "street" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IpSapPortData" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "bfd" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMinimumInterval" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMultiplier" } },
          { kind: "Field", name: { kind: "Name", value: "bgpExportPolicy" } },
          { kind: "Field", name: { kind: "Name", value: "bgpHashAlgorithm" } },
          { kind: "Field", name: { kind: "Name", value: "bgpPassword" } },
          { kind: "Field", name: { kind: "Name", value: "bgpSessionPriority" } },
          { kind: "Field", name: { kind: "Name", value: "gracefulRestart" } },
          { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "ipPrefixes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv4PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv6PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpBgpSubscriptionDetailsQuery, IpBgpSubscriptionDetailsQueryVariables>;
export const IpStaticSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IpStaticSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ipStaticDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "protection" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "ipRoutingType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ipss" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "surfcertFilter" } },
                      { kind: "Field", name: { kind: "Name", value: "asn" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saps" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IpSapData" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topology" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapPortData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "port" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MinifiedLinkedServicesFragment" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "addition" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                            { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                            { kind: "Field", name: { kind: "Name", value: "number" } },
                            { kind: "Field", name: { kind: "Name", value: "street" } },
                            { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IpSapData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IPServiceAttachPointType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IpSapPortData" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "bfd" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMinimumInterval" } },
          { kind: "Field", name: { kind: "Name", value: "bfdMultiplier" } },
          { kind: "Field", name: { kind: "Name", value: "bgpExportPolicy" } },
          { kind: "Field", name: { kind: "Name", value: "bgpHashAlgorithm" } },
          { kind: "Field", name: { kind: "Name", value: "bgpPassword" } },
          { kind: "Field", name: { kind: "Name", value: "bgpSessionPriority" } },
          { kind: "Field", name: { kind: "Name", value: "gracefulRestart" } },
          { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "ipPrefixes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv4PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ipv6PointToPointPrefix" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "clientIpAddress" } },
                { kind: "Field", name: { kind: "Name", value: "network" } },
                { kind: "Field", name: { kind: "Name", value: "surfFQDN" } },
                { kind: "Field", name: { kind: "Name", value: "surfIpAddress" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IpStaticSubscriptionDetailsQuery, IpStaticSubscriptionDetailsQueryVariables>;
export const IrbSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IrbSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "irbDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "surfLocationCode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "portId" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "portSubscription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "street" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IrbSubscriptionDetailsQuery, IrbSubscriptionDetailsQueryVariables>;
export const L2vpnSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "L2vpnSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "l2vpnDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "protection" } },
                { kind: "Field", name: { kind: "Name", value: "speedPolicer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "circuits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endpoints" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "organisation" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                            { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "portMode" } },
                                  { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                                  { kind: "Field", name: { kind: "Name", value: "tags" } },
                                  { kind: "Field", name: { kind: "Name", value: "speed" } },
                                  { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "services" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                                        { kind: "Field", name: { kind: "Name", value: "insync" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topology" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saps" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "port" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "portMode" } },
                            { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                            { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                            { kind: "Field", name: { kind: "Name", value: "speed" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "fullname" } },
                                  { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "services" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locations" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "addition" } },
                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                        { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                        { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                        { kind: "Field", name: { kind: "Name", value: "number" } },
                                        { kind: "Field", name: { kind: "Name", value: "street" } },
                                        { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "esis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "segmentId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firewallInterconnect" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "firewallSubscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endpoints" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                            { kind: "Field", name: { kind: "Name", value: "organisation" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                            { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                                  { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                                  { kind: "Field", name: { kind: "Name", value: "tags" } },
                                  { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                                  { kind: "Field", name: { kind: "Name", value: "usedVlans" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "customer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "fullname" } },
                                        { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locations" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "address" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "addition" } },
                                              { kind: "Field", name: { kind: "Name", value: "city" } },
                                              { kind: "Field", name: { kind: "Name", value: "number" } },
                                              { kind: "Field", name: { kind: "Name", value: "street" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "addition" } },
                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                        { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                        { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                        { kind: "Field", name: { kind: "Name", value: "number" } },
                                        { kind: "Field", name: { kind: "Name", value: "street" } },
                                        { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "services" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "product" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                        { kind: "Field", name: { kind: "Name", value: "tag" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firewallInterconnects" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "availabilityZone" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "firewallSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endpoints" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L2vpnSubscriptionDetailsQuery, L2vpnSubscriptionDetailsQueryVariables>;
export const L3vpnSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "L3vpnSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "l3vpnDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "firewallEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "insync" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "protection" } },
                { kind: "Field", name: { kind: "Name", value: "speedPolicer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "references" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "externalId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "circuits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endpoints" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "organisation" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                            { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                                  { kind: "Field", name: { kind: "Name", value: "portMode" } },
                                  { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                                  { kind: "Field", name: { kind: "Name", value: "tags" } },
                                  { kind: "Field", name: { kind: "Name", value: "speed" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "services" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                                        { kind: "Field", name: { kind: "Name", value: "insync" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topology" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "product" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "l3vpnss" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "l3vpnAsn" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "l3vpnsapss" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "bfd" } },
                      { kind: "Field", name: { kind: "Name", value: "bfdMinimumInterval" } },
                      { kind: "Field", name: { kind: "Name", value: "bfdMultiplier" } },
                      { kind: "Field", name: { kind: "Name", value: "bgpPassword" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "bgpMetric" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4Address" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4MaxPrefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6Address" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4RemoteAddress" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6MaxPrefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6RemoteAddress" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sap" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                            { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "port" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "domain" } },
                                  { kind: "Field", name: { kind: "Name", value: "portMode" } },
                                  { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                                  { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                                  { kind: "Field", name: { kind: "Name", value: "speed" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                                  { kind: "Field", name: { kind: "Name", value: "tags" } },
                                  { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "product" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "tag" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "customer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "fullname" } },
                                        { kind: "Field", name: { kind: "Name", value: "customerId" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "services" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "addition" } },
                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                        { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                        { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                        { kind: "Field", name: { kind: "Name", value: "number" } },
                                        { kind: "Field", name: { kind: "Name", value: "street" } },
                                        { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locations" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "address" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "addition" } },
                                              { kind: "Field", name: { kind: "Name", value: "city" } },
                                              { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                              { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                              { kind: "Field", name: { kind: "Name", value: "number" } },
                                              { kind: "Field", name: { kind: "Name", value: "street" } },
                                              { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firewallInterconnects" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "availabilityZone" } },
                      { kind: "Field", name: { kind: "Name", value: "firewallAsn" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6Mtu" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4Prefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6Prefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4MaxPrefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6MaxPrefix" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv4AddressFirewall" } },
                      { kind: "Field", name: { kind: "Name", value: "ipv6AddressFirewall" } },
                      { kind: "Field", name: { kind: "Name", value: "firewallSubscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saps" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "tag" } },
                            { kind: "Field", name: { kind: "Name", value: "organisation" } },
                            { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MinifiedLinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<L3vpnSubscriptionDetailsQuery, L3vpnSubscriptionDetailsQueryVariables>;
export const LightpathSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LightpathSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lpDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "LightPathSubscriptionDetailsFragment" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LightPathSubscriptionDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LightPathSubscriptionDetailsType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
          { kind: "Field", name: { kind: "Name", value: "domain" } },
          { kind: "Field", name: { kind: "Name", value: "protection" } },
          { kind: "Field", name: { kind: "Name", value: "serviceId" } },
          { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "speedPolicer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "saps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "organisation" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "circuits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "remotePortShutdown" } },
                { kind: "Field", name: { kind: "Name", value: "serviceId" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endpoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "port" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "portMode" } },
                            { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                            { kind: "Field", name: { kind: "Name", value: "speed" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "usedVlans" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "customerId" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "services" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topology" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LightpathSubscriptionDetailsQuery, LightpathSubscriptionDetailsQueryVariables>;
export const LightpathRedundantSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LightpathRedundantSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lrDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "LightPathSubscriptionDetailsFragment" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LightPathSubscriptionDetailsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LightPathSubscriptionDetailsType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
          { kind: "Field", name: { kind: "Name", value: "domain" } },
          { kind: "Field", name: { kind: "Name", value: "protection" } },
          { kind: "Field", name: { kind: "Name", value: "serviceId" } },
          { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "speedPolicer" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "saps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "organisation" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "circuits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "remotePortShutdown" } },
                { kind: "Field", name: { kind: "Name", value: "serviceId" } },
                { kind: "Field", name: { kind: "Name", value: "serviceSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "endpoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "organisation" } },
                      { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "port" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                            { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "portMode" } },
                            { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                            { kind: "Field", name: { kind: "Name", value: "speed" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "usedVlans" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "customerId" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "tag" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "services" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "addition" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "extraAddressLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "number" } },
                                  { kind: "Field", name: { kind: "Name", value: "street" } },
                                  { kind: "Field", name: { kind: "Name", value: "zipcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topology" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                { kind: "Field", name: { kind: "Name", value: "otherSubscriptionId" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "topologyObjectType" } },
                { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LightpathRedundantSubscriptionDetailsQuery,
  LightpathRedundantSubscriptionDetailsQueryVariables
>;
export const AggspSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AggspSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aggspDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "surfLocationCode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "portId" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "portSubscription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linkMemberSubscriptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkMemberFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "street" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkMemberFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LinkMemberDetailsType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "patchPosition" } },
          { kind: "Field", name: { kind: "Name", value: "ieeeInterfaceType" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AggspSubscriptionDetailsQuery, AggspSubscriptionDetailsQueryVariables>;
export const MscSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MscSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mscDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "surfLocationCode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "portId" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                { kind: "Field", name: { kind: "Name", value: "subscriptionInstanceId" } },
                { kind: "Field", name: { kind: "Name", value: "serviceTag" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "street" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "portSubscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerId" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MscSubscriptionDetailsQuery, MscSubscriptionDetailsQueryVariables>;
export const PortSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PortSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "servicePortDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "locationDescription" } },
                { kind: "Field", name: { kind: "Name", value: "surfLocationCode" } },
                { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
                { kind: "Field", name: { kind: "Name", value: "portMode" } },
                { kind: "Field", name: { kind: "Name", value: "autoNegotiation" } },
                { kind: "Field", name: { kind: "Name", value: "patchPosition" } },
                { kind: "Field", name: { kind: "Name", value: "fiberType" } },
                { kind: "Field", name: { kind: "Name", value: "connectorType" } },
                { kind: "Field", name: { kind: "Name", value: "ieeeInterfaceType" } },
                { kind: "Field", name: { kind: "Name", value: "domain" } },
                { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "street" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "LinkedServicesFragment" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregateParent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
                      { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedServicesFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ServiceType" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "portSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "sapSubscriptionInstanceId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "speed" } },
          { kind: "Field", name: { kind: "Name", value: "percentage" } },
          { kind: "Field", name: { kind: "Name", value: "vlanrange" } },
          { kind: "Field", name: { kind: "Name", value: "portSpeed" } },
          { kind: "Field", name: { kind: "Name", value: "amountReserved" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "speed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortSubscriptionDetailsQuery, PortSubscriptionDetailsQueryVariables>;
export const WiredSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WiredSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wiredDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "monitoringEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "customCustomerAbbreviation" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WiredSubscriptionDetailsQuery, WiredSubscriptionDetailsQueryVariables>;
export const WirelessSubscriptionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WirelessSubscriptionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wirelessDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subscriptionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "BaseSubscriptionFragment" } },
                { kind: "Field", name: { kind: "Name", value: "sensorPresent" } },
                { kind: "Field", name: { kind: "Name", value: "supplier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessPoints" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "brand" } },
                            { kind: "Field", name: { kind: "Name", value: "model" } },
                            { kind: "Field", name: { kind: "Name", value: "supplier" } },
                            { kind: "Field", name: { kind: "Name", value: "ciStatus" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tickets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ticketId" } },
                      { kind: "Field", name: { kind: "Name", value: "summary" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      { kind: "Field", name: { kind: "Name", value: "locations" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "product" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BaseSubscriptionFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubscriptionDetails" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "insync" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "organisation" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionId" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "customerDescription" } },
          { kind: "Field", name: { kind: "Name", value: "minimalImpactNotification" } },
          { kind: "Field", name: { kind: "Name", value: "dirty" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "product" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tag" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "references" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WirelessSubscriptionDetailsQuery, WirelessSubscriptionDetailsQueryVariables>;
export const WirelessOrganisationTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WirelessOrganisationTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wirelessOrganisationTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCustomerId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accessCustomerId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ticketId" } },
                { kind: "Field", name: { kind: "Name", value: "summary" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "status" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "locations" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WirelessOrganisationTicketsQuery, WirelessOrganisationTicketsQueryVariables>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    SubscriptionDetails: [
      "AggspSubscriptionDetailsType",
      "FirewallSubscriptionDetailsType",
      "FirewallSubscriptionType",
      "IpPrefixSubscriptionType",
      "IpSubscriptionDetailsType",
      "IpSubscriptionListType",
      "IrbSubscriptionDetailsType",
      "L2VPNSubscriptionDetailsType",
      "L3VPNSubscriptionDetailsType",
      "LightPathSubscriptionDetailsType",
      "LightPathSubscriptionType",
      "MscSubscriptionDetailsType",
      "ServicePortSubscriptionDetailsType",
      "WiredSubscriptionDetailsType",
      "WiredSubscriptionType",
      "WirelessSubscriptionDetailsType",
      "WirelessSubscriptionType",
    ],
  },
};
export default result;
